import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchInsights() {
  const { data } = await axios.get(`${API}/insights`);
  return data.articles || [];
}

export async function fetchInsight(slug) {
  const { data } = await axios.get(`${API}/insights/${slug}`);
  return data;
}

export function formatDate(iso, lang = "fr") {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(lang === "fr" ? "fr-FR" : "en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch (_) {
    return iso;
  }
}
